var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { gql } from "@apollo/client";
export var DELETE_ROLE = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    mutation DeleteRole($tenantId: String!, $roleId: String!) {\n        delete_role(tenant_id: $tenantId, role_id: $roleId) {\n            id\n        }\n    }\n"], ["\n    mutation DeleteRole($tenantId: String!, $roleId: String!) {\n        delete_role(tenant_id: $tenantId, role_id: $roleId) {\n            id\n        }\n    }\n"])));
var templateObject_1;
